import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import SecureShredding from './components/SecureShredding';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';

function App() {
  return (
    <div className="bg-white">
      <Header />
      <main>
        <Hero />
        <AboutUs />
        <Services />
        <SecureShredding />
        <ContactUs />
      </main>
      <Footer />
    </div>
  );
}

export default App;